import { initializeApp } from '@firebase/app';
import { getAuth, initializeAuth, browserLocalPersistence, browserSessionPersistence } from '@firebase/auth';
import { getFirestore } from '@firebase/firestore';
import { getFunctions } from '@firebase/functions';
import { getStorage } from '@firebase/storage';
import firebaseConfig from './firebaseConfig';

// Initialize Firebase app with explicit region
const app = initializeApp(firebaseConfig);

// Local first so a saved login survives refresh. Session is included so a
// Remember-me-off login (sessionStorage) is found and moved into local storage.
// ponytail: SDK migrates that session user into local persistence on the next load.
const auth = initializeAuth(app, {
  persistence: [browserLocalPersistence, browserSessionPersistence]
});

// Initialize other services with region
const db = getFirestore(app);
const functions = getFunctions(app, process.env.REACT_APP_FIREBASE_FUNCTIONS_REGION || 'us-central1');
const storage = getStorage(app);

// If you're using local emulator, uncomment this:
// connectFunctionsEmulator(functions, "localhost", 5001);

// Export initialized services
export { app, auth, db, storage, functions };

// Export getters for backward compatibility
export const getFirebaseApp = () => app;
export const getFirebaseAuth = () => auth;
export const getFirebaseDb = () => db;
export const getFirebaseStorage = () => storage;
export const getFirebaseFunctions = () => functions;
